import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '@/stores';

const PopupContainer = observer((): JSX.Element => {
  const { dialogStore } = useStores();

  return (
    <div style={{ pointerEvents: 'initial' }}>
      {dialogStore.popups.map((item) => (
        <React.Fragment key={item.seq}>{item.element}</React.Fragment>
      ))}
    </div>
  );
});

export default PopupContainer;
